import { useEffect, useState } from 'react';
import { cockpitApi } from '../services/api';

// Simple singleton fetch-once-and-share cache for the cockpit explorer
// dataset (zones/views/controls/multi_step_locates) - small, static,
// read by many components (overview, explorer, sidebar, checklist locate
// icons), so we only fetch it once per app session.
let cachedData = null;
let inflightPromise = null;

const fetchExplorerData = () => {
  if (cachedData) return Promise.resolve(cachedData);
  if (!inflightPromise) {
    inflightPromise = cockpitApi.getExplorer().then((res) => {
      cachedData = res.data;
      return cachedData;
    });
  }
  return inflightPromise;
};

export const useCockpitExplorer = () => {
  const [data, setData] = useState(cachedData);
  const [loading, setLoading] = useState(!cachedData);

  useEffect(() => {
    if (cachedData) {
      setData(cachedData);
      setLoading(false);
      return;
    }
    let active = true;
    fetchExplorerData()
      .then((d) => {
        if (active) {
          setData(d);
          setLoading(false);
        }
      })
      .catch(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return { data, loading };
};
